module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmallBlackH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmallBlackH.svg
// module id = 243
// module chunks = 0